var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table-cell-text',[_c('app-widget-seats',{attrs:{"seats":_vm.item.seats.total,"indexed":_vm.item.seats.indexed,"taken":_vm.item.seats.taken,"joined":_vm.item.session.is.sitting,"show-full":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }